import React, { useContext } from 'react'
import { navigate } from 'gatsby'
import { Box } from '@rebass/grid/emotion'

import PageContext from './pageContext'
import { linkCSSInverted, colors } from '../styles/variables'
import css from '@emotion/css'

const Langs = () => {
  const { locale, languages, originalPath } = useContext(PageContext)
  const handleSetLang = language => {
    const newPathname = `/${language}${originalPath}`
    localStorage.setItem('language', language)
    navigate(newPathname)
  }

  return languages
    .map((lang, k) => <Box
      p={0}
      ml={2}
      key={k}
      onClick={() => locale !== lang.locale && handleSetLang(lang.locale)}
    >{locale !== lang.locale
      ? <a css={linkCSSInverted}>{lang.label}</a>
      : <a css={[linkCSSInverted, css`
        cursor: initial;
        color: ${colors.white};
        user-select: none;
      `]}>{lang.label}</a>
      }
    </Box>
    )
}

export default Langs